// pages/blog.js
import { BlogAPI } from '../../apis/BlogAPI'
import BlogSection from '../../components/BlogSection'
import BlogWrapper from '../../components/BlogWrapper'
import { getBlogWrapperPosts } from '../../helpers/blog'

export async function getStaticProps() {
    const { data: posts, headers } = await BlogAPI.safeRequest(
        () => BlogAPI.getBlogPosts(),
        { data: [], headers: { 'x-wp-totalpages': '0' } },
        'blog index getBlogPosts',
    )
    const totalPages = parseInt(headers['x-wp-totalpages'], 10)

    const page = await BlogAPI.safeRequest(
        () => BlogAPI.getPageBySlug('/home'),
        { data: [] },
        'blog index getPageBySlug /home',
    )
    const pageData = page ? page.data[0] : {}

    const { initialCategories, latestBlogPosts, tags, popularPosts } =
        await getBlogWrapperPosts()

    return {
        props: {
            initialPosts: posts,
            initialCategories,
            initialTotalPages: totalPages,
            latestBlogPosts,
            tags, // Include tags in the props
            popularPosts,
            pageData,
        },
        revalidate: 10, // In seconds
    }
}

export default function BlogPage({
    initialPosts,
    initialCategories,
    initialTotalPages,
    pageTitle,
    latestBlogPosts,
    tags, // Add initialTags prop
    popularPosts,
    pageData,
}) {
    const title = pageTitle ? pageTitle : 'Blog'

    return (
        <BlogWrapper
            {...{
                title,
                latestBlogPosts,
                initialCategories,
                tags,
                popularPosts,
                pageData,
            }}>
            <BlogSection
                initialPage={1}
                initialPosts={initialPosts}
                initialCategories={initialCategories}
                initialTotalPages={initialTotalPages}
                isBlog={true}
            />
        </BlogWrapper>
    )
}
